import useAppSelector from '../app/redux/useAppSelector';
import { UserType } from '../graphql/generated/graphql';
import { isFeatureEnabled } from '../utils/features';

const ALLOWED_USER_TYPES = new Set([UserType.Admin, UserType.User]);

const useAiCopilotEnabled = () =>
  useAppSelector(
    (state) =>
      isFeatureEnabled('ai_copilot') &&
      ALLOWED_USER_TYPES.has(state.session.user.type) &&
      // TODO: Separate setting
      !!state.session.user.settings.aiAsk,
  );

export default useAiCopilotEnabled;
